export const armenianTextRegex =
  /^[\u0531-\u0556\u0561-\u0587\u0559-\u055F\s'-]*$/;
export const OGRNIP_MAX_LENGTH = 15;

export const isValidArmenianText = (value?: string) => {
  if (!value) return true;
  return armenianTextRegex.test(value.trim());
};

export const getInvalidFormFieldNames = (form: HTMLFormElement | null) => {
  if (!form) return [];

  return Array.from(form.querySelectorAll(":invalid")).map((element) => {
    const field = element as
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

    return (
      field.name ||
      field.getAttribute("aria-label") ||
      field.getAttribute("name") ||
      "unknown"
    );
  });
};

export const shouldLog = () => {
  return process.env.NODE_ENV === "development";
};

export const getNormalizedOgrnip = (value?: string) => {
  return String(value ?? "").replace(/\D/g, "");
};

export const isOgrnipTooLong = (value?: string) => {
  return getNormalizedOgrnip(value).length > OGRNIP_MAX_LENGTH;
};
